define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var Template = require('text!tmpls/header_right.tpl').default;
    var Backbone = require('backbone');
    var _ = require('underscore');
    var Model = require('models/header_alerts');
    var I18n = require('i18n!nls/main');
    I18n.init('ru-ru');

    var NotepadCollection = require('collections/notepad');
    var AppConfig = require('config/application');

    var ChatView = require('views/header/chat');
    var TasksView = require('views/header/tasks');
    var CallsViews = require('views/header/calls');
    var MessagesViews = require('views/header/messages');
    var NewsView = require('views/header/news');
    // var AlertView 	= require('views/header/alerts');
    var confirmMessage = I18n.basic.confirm_exit;

    return Marionette.LayoutView.extend({
        template: Template,
        className: 'group-btns-right',
        tagName: 'ul',

        regions: {
            regionChat: '.js-region-chat-alerts',
            regionTasks: '.js-region-tasks-alerts',
            regionCalls: '.js-region-calls-alerts',
            regionMessages: '.js-region-messages-alerts',
            regionNews: '.js-region-news'
            // regionAlert 	: '.js-region-alerts-alerts'
        },

        loading: false,
        firstWindowListening: true,

        initialize: function () {
            //_.bindAll(this, 'fetchModel');
            this.model = new Model();
            this.listenTo(this.model, 'sync', this.afterSync);
            // setTimeout(function() {
            //     this.fetchModel();
            //     setInterval(this.fetchModel, app.update_interval);
            // }.bind(this), 7000);

            //this.listenTo(app.Vents, 'miss_calls:delete notices:delete tasks:complete', this.fetchModel);
            $(window).on('mousedown keydown', this.setupListeners.bind(this));

            // app.Collections.Notes = new NotepadCollection();
            this.callsView = new CallsViews();
            this.messagesView = new MessagesViews();
            if(app.curPage && app.curPage.openedPanel) {
                this.preventExit = true;
                this.listenTo(app.Vents, 'Panel:hided', this.panelHided);
            }
            this.listenTo(app.Vents,
                'app:changeProject', app.Views.Header.hideRightSidebar()
            );
        },

        setupListeners: function () {
            if (!this.firstWindowListening) return;
            this.firstWindowListening = false;

            $(window).off('mousedown keydown', this.setupListeners.bind(this));
            this.listenTo(app.Vents, 'Panel:showed page:preventExit', this.panelShowed);
            this.listenTo(app.Vents, 'page:dontPreventExit', this.panelHided);
        },

        fetchModel: function () {
            if (typeof this.model !== 'undefined') {
                this.model.fetch();
            }
        },

        afterSync: function () {
            app.Collections.Notices = new Backbone.Collection(this.model.get('notifications'));
            //app.Collections.Tasks = new TasksCollection(this.model.get('tasks'));
            // app.Collections.Notes.reset(this.model.get('notes'));
            this.callsView = new CallsViews();
            this.messagesView = new MessagesViews();
            this.showRegions();
        },

        showRegions: function () {
            const product = app.Models.User.get('product');

            if (!product || product.options.notes) {
                this.regionChat.show(new ChatView());
            }
            if (!app.checkAccess('tasks') && (!product || product.options.tasks)) {
                this.regionTasks.show(new TasksView(this.model.get('tasks')));
            }
            if (!product || product.options.calls) {
                this.regionCalls.show(this.callsView);
            }
            if (!product || product.options.new_messages) {
                this.regionMessages.show(this.messagesView);
            }
        },

        onShow: function () {
            this.showRegions();
        },

        onRender: function() {
            this.$('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            });
        },

        onDestroy: function () {
            this.model.off('sync', this.afterSync, this);
        },

        panelShowed: function (handler) {
            if (this.preventExit) return;
            if (app.Temp.leadCardLoaded === false && typeof app.Temp.SimcardPageOpen == 'undefined') return;
            this.stopListening(app.Vents, 'Panel:showed', this.panelShowed);
            this.preventExit = true;
            window.onbeforeunload = handler || this.beforeExit;
            confirmMessage = window.onbeforeunload();
            this.elementsList = 'a[href], .js-change-template, #js-header-project-name-region, #b-header .js-popover, .js-region-tasks-alerts';
            this.notListenTo = '#layout-condensed-toggle, a[href*="javascript"], a[role="tab"], .certain_days_nav a';

            app.curPage.$('.js-back').off('click').on('click', this.confirmExit);
            $(this.elementsList).not(this.notListenTo).off('click', this.confirmExit);
            $(this.elementsList).not(this.notListenTo).on('click', this.confirmExit);
            this.listenTo(app.Vents, 'Panel:hided', this.panelHided);
        },

        panelHided: function () {
            if (!this.preventExit) return;
            this.stopListening(app.Vents, 'Panel:hided', this.panelHided);
            this.preventExit = false;
            window.onbeforeunload = null;
            app.curPage.$('.js-back').off('click', this.confirmExit);
            $(this.elementsList).not(this.notListenTo).off('click', this.confirmExit);
            this.listenTo(app.Vents, 'Panel:showed', this.panelShowed);
        },

        beforeExit: function () {
            return I18n.basic.confirm_exit;
        },

        confirmExit: function (e) {
            var $el = $(e.target),
                href = $.trim($el.attr('href'));

            // Если элемент с пустым атрибутом href или href="javascript:{}"
            if ($el.prop("tagName").toLowerCase() == 'a' && href.length < 2 || href.indexOf('javascript') !== -1) return;

            e.preventDefault();
            e.stopPropagation();

            var confirmation = confirm(confirmMessage);
            if (confirmation) {
                app.Vents.trigger('page:dontPreventExit');
                app.curPage.hidePanelBtns();
                app.curPage.$('.js-back').off('click');
                $el.trigger('click');
                if (href && href.length > 2) {
                    location.href = href;
                }
            }
            return confirmation;
        },
    });
});
